import { generateClient } from "aws-amplify/api";
import { transformExternalUser, transformUser } from "./transform";
import { SET_USER, USER_STATUS } from "../actions-index";
import * as Queries from "../graphql/queries";
import * as CustomQueries from "../graphql/custom";
import { ACTION_STATUS, AWS_LAMBDA, STORAGE_KEY_STUDENT_PROXY, STORAGE_KEY_EXTERNAL_USER_KEYS } from "../util/constants";

const API = generateClient();

async function getUser() {
    const userDetails = Object.freeze((((await API.graphql({ query: Queries.getUserDetails }))?.data?.getUserDetails?.userDetails) ?? null));
    if(userDetails === null) throw new Error("User Not Found");
    return transformUser(userDetails);
}

export function recievedSetUser(user) {
    return {
        type: SET_USER,
        payload: Object.keys(user || {}).length > 0 ? user : null
    }
}

export function setUserStatus(status) {
    return {
        type: USER_STATUS,
        payload: status
    }
}

export function getExternalUserInfo(externalUserId, accessToken) {
    return async (dispatch, getState) => {
        let  user;
        dispatch(setUserStatus("loading"))
        try {
            const graphqlParams = {
                query: CustomQueries.getExternalUserInfo,
                authMode: AWS_LAMBDA,
                authToken: `${externalUserId}:${accessToken}`
            }
            const response = await API.graphql(graphqlParams);
            const data = response?.data?.getExternalUserInfo;
                if(response?.status) {
                    dispatch(setUserStatus(response?.status))
                }
                if(['error', 'cleared'].includes(response?.status)) {
                    dispatch(recievedSetUser({}));
                } else {
                    let externalUserSessionKeys = { akey: accessToken, ukey: externalUserId }
                    sessionStorage.setItem(STORAGE_KEY_EXTERNAL_USER_KEYS, JSON.stringify(externalUserSessionKeys))
                    user = transformExternalUser({...data, externalKeys: externalUserSessionKeys})
                    dispatch(recievedSetUser(user))
                }
        } catch (error) {
            console.error("getExternalUser Action-ERROR:", error)
            throw error;
        }
        
        return user;
    }
}

export function receiveAmplifyHubUser(response = {}) {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const authStatus = state.authentication.status;
            
            let studentProxy = {};
            const studentProxyString = sessionStorage.getItem(STORAGE_KEY_STUDENT_PROXY);
            if(studentProxyString) {
                try {
                    studentProxy = JSON.parse(studentProxyString);
                } catch(error) {
                    console.error("Failed to parse student proxy from storage", error);
                    sessionStorage.removeItem(STORAGE_KEY_STUDENT_PROXY);
                }
            }

            const stateOsuId = state?.authentication?.user?.osuid
            let responseOsuid = (studentProxy?.osuid || response?.osuid || response?.displayName);

            if(![ACTION_STATUS.UNAUTHORIZED, ACTION_STATUS.ERROR].includes(authStatus)) {
                if(response?.status) {
                    dispatch(setUserStatus(response?.status))
                }
                if(['error', 'cleared'].includes(response?.status)) {
                    dispatch(recievedSetUser({}));
                } else if(responseOsuid && (stateOsuId !== responseOsuid)) {
                    if(studentProxy?.osuid) {
                        dispatch(recievedSetUser(studentProxy));
                    } else {
                        const user = await getUser();
                        dispatch(recievedSetUser(user));
                    }
                }
            }   
        } catch (error) {
            console.error(error)
            dispatch(setUserStatus("error"))
        }
    }
}